export default __webpack_public_path__ + "static/media/approved_sp_data_not_found.d079c337.svg";